/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NbAlertModule, NbInputModule, NbButtonModule, NbLayoutModule, NbSpinnerModule, NbCardModule } from '@nebular/theme';
import { NgIf, NgFor } from '@angular/common';
import { ApiService } from '../../../services/api/api.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StatusIconDirective } from "../../../directives/status-icon.directive";

@Component({
    selector: 'nb-forgot-password-page',
    styleUrls: ['./forgot-password.component.scss'],
    templateUrl: './forgot-password.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf, NbAlertModule, NgFor, FormsModule, NbInputModule, NbButtonModule, RouterLink, NbLayoutModule, NbSpinnerModule, NbCardModule, TranslateModule, StatusIconDirective]
})
export class NbForgotPasswordComponent {

  redirectDelay: number = 0;
  showMessages = { error: true, success: true };
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(private apiService: ApiService,
    private cd: ChangeDetectorRef,
    public router: Router,
    public translate: TranslateService) {

    // this.redirectDelay = this.getConfigValue('forms.requestPassword.redirectDelay');
    // this.showMessages = this.getConfigValue('forms.requestPassword.showMessages');
    // this.strategy = this.getConfigValue('forms.requestPassword.strategy');
  }

  async requestPass(): Promise<void> {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    try {
      const email = this.user.email.trim().toLowerCase()
      const response = await this.apiService.forgotPassword(email)
      this.messages = [this.translate.instant('auth.forgotPassword.successMessage')];
    } catch (error) {
      this.errors = [this.translate.instant('auth.forgotPassword.errorMessage')]
    } finally {
      this.submitted = false;
      this.cd.detectChanges();
    }
  }

  getConfigValue(key: string): any {
    const config: { [key: string]: any } = {
      'forms.validation.email.required': true,
    };
    return config[key] ?? null;
  }
}
